import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { ErrorResponse } from '../models/shared';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getErrorResponse = (error:FetchBaseQueryError | SerializedError): ErrorResponse => (error as any).data as ErrorResponse;

export default getErrorResponse;
